(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Header-David"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-slider-AR"] && !Shopify.designMode) return;
  try {
    
  class CustomCarousel {
    constructor(sectionElement) {
      this.section = sectionElement;
      this.wrapper = this.section.querySelector('[data-carousel-wrapper]');
      this.prevButton = this.section.querySelector('[data-carousel-prev]');
      this.nextButton = this.section.querySelector('[data-carousel-next]');
      this.nav = this.section.querySelector('[data-carousel-nav]');
      if (!this.wrapper || !this.prevButton) {
        return;
      }
      this.init();
    }

    init() {
      this.prevButton.addEventListener('click', this.scroll.bind(this, 'prev'));
      this.nextButton.addEventListener('click', this.scroll.bind(this, 'next'));
      this.wrapper.addEventListener('scroll', this.updateButtonState.bind(this));
      this.observer = new ResizeObserver(() => this.checkScrollability());
      this.observer.observe(this.wrapper);
      
      window.addEventListener('resize', this.checkScrollability.bind(this));
    }

    /* --- CORRECCIÓN: Scroll uno por uno --- */
    scroll(direction) {
      const firstItem = this.wrapper.querySelector('.collection-item');
      if (!firstItem) return;

      // Calcular el ancho del item
      const itemWidth = firstItem.offsetWidth;
      // Calcular el 'gap' del contenedor
      const itemGap = parseFloat(window.getComputedStyle(this.wrapper).gap) || 0;
      // El scroll es la suma de ambos
      const scrollAmount = itemWidth + itemGap;
      if (direction === 'prev') {
        this.wrapper.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      } else {
        this.wrapper.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    }

    checkScrollability() {
      if (!this.wrapper || !this.nav) return;
      const isScrollable = this.wrapper.scrollWidth > this.wrapper.clientWidth;
      
      this.nav.style.display = isScrollable ? 'block' : 'none';
      if (isScrollable) {
        this.updateButtonState();
      }
    }
    
    updateButtonState() {
      if (!this.wrapper || !this.prevButton || !this.nextButton) return;
      const scrollLeft = Math.round(this.wrapper.scrollLeft);
      const scrollWidth = this.wrapper.scrollWidth;
      const clientWidth = this.wrapper.clientWidth;
      
      const atStart = scrollLeft <= 1;
      this.prevButton.style.display = atStart ? 'none' : 'flex';
      
      const atEnd = (scrollLeft + clientWidth) >= (scrollWidth - 1);
      this.nextButton.style.display = atEnd ? 'none' : 'flex';
    }
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList.contains('custom-collection-list-section')) {
      new CustomCarousel(event.target);
    }
  });
  document.querySelectorAll('.custom-collection-list-section').forEach(section => {
    new CustomCarousel(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;

      this.stickyType = this.getAttribute('data-sticky-type') || 'none';
      this.hideOnScrollEnabled = this.getAttribute('data-hide-on-scroll') === 'true' || this.stickyType === 'on-scroll-up';
      this.headerIsAlwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      this.preventReveal = false;
      this.preventHide = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.addEventListener('resize', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky || this.hideOnScrollEnabled) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.onDetailsToggleHandler = this.onDetailsToggle.bind(this);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.header.addEventListener('toggle', this.onDetailsToggleHandler, true);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.setHeaderHeight.bind(this));
      if (this.header) this.header.removeEventListener('toggle', this.onDetailsToggleHandler, true);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    isMobileMenuOpen() {
      return Boolean(
        this.header.querySelector('header-drawer details[open], menu-drawer[open], .menu-opening, details[open].menu-drawer-container')
      );
    }

    onDetailsToggle() {
      if (this.isMobileMenuOpen()) {
        this.header.classList.add('menu-open', 'shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      } else {
        this.header.classList.remove('menu-open');
      }
    }

    onScroll() {
      if (!this.hideOnScrollEnabled && !this.headerIsAlwaysSticky) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const goingDown = scrollTop > this.currentScrollTop;
      const goingUp = scrollTop < this.currentScrollTop;
      const minScrollBeforeHide = Math.max(this.headerBounds.bottom || this.header.offsetHeight || 0, 80);

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isMobileMenuOpen()) {
        this.reveal();
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop <= 0) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
        this.currentScrollTop = scrollTop;
        return;
      }

      if (goingDown && scrollTop > minScrollBeforeHide) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventHide) requestAnimationFrame(this.hide.bind(this));
      } else if (goingUp && scrollTop > minScrollBeforeHide) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= minScrollBeforeHide) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.header.classList.remove('animate');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => {
        if (typeof disclosure.close === 'function') disclosure.close();
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
